import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { REPORT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SystemDashboardPage } from '@/features/dashboards/pages/SystemDashboardPage';
import { systemDashboardListSearchSchema } from '@/features/dashboards/types/dashboard.types';

export const Route = createFileRoute('/_auth/dashboards/system/')({
  beforeLoad: () => requirePermission(REPORT_PERMISSIONS.SYSTEM_DASHBOARD_VIEW),
  validateSearch: systemDashboardListSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="System Dashboard">
      <Suspense fallback={<PageLoader />}>
        <SystemDashboardPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
